import { Spinner } from 'react-bootstrap';

export default function BaseThrobber({
  label = 'Loading...',
  details = null,
  className = 'd-inline-flex align-items-center gap-2 px-3 py-2 rounded-3 bg-dark bg-opacity-75 text-white shadow-sm',
  style,
  textClassName = 'small fw-semibold',
  detailsClassName = 'small text-white-50',
  detailsStyle,
  contentClassName = 'd-flex flex-column',
  spinnerAnimation = 'border',
  spinnerSize = 'sm',
  spinnerClassName = '',
  ariaLive = 'polite',
  spinnerLabel = 'Loading',
  ...rest
}) {
  return (
    <div className={className} style={style} aria-live={ariaLive} {...rest}>
      <Spinner
        animation={spinnerAnimation}
        size={spinnerSize}
        role="status"
        className={spinnerClassName}
      >
        <span className="visually-hidden">{spinnerLabel}</span>
      </Spinner>
      {(label || details) && (
        <div className={contentClassName}>
          {label ? <span className={textClassName}>{label}</span> : null}
          {details ? (
            <span className={detailsClassName} style={detailsStyle}>
              {details}
            </span>
          ) : null}
        </div>
      )}
    </div>
  );
}
